import { useEffect, useState } from "react";
import { groupApi } from "../group/group-api";
import { Group } from "../group/types";

interface GroupSelectionPageProps {
  onSelectGroups: (groups: Group[]) => void;
  onClose: () => void;
}

export default function GroupSelectionPage({
  onSelectGroups,
  onClose,
}: GroupSelectionPageProps) {

  const [groups, setGroups] = useState<Group[]>([])

  const [isLoading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null);

  const fetchGroups = async () => {
    try {
      setLoading(true);
      const data = await groupApi.getAllGroups() as any;
      setGroups(data.data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  const handleGroupToggle = (teamId: number) => {
    setGroups((prev) =>
      prev.map((team) =>
        team.id === teamId ? { ...team, selected: !team.selected } : team
      )
    );
  };

  const handleAddSelected = () => {
    const selectedGroups = groups.filter((team) => team.selected);
    onSelectGroups(selectedGroups);
    onClose();
  };


  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white dark:bg-neutral-800 rounded-2xl shadow-xl max-w-5xl w-full p-8 relative mt-8">
        <div className="relative  bg-neutral-50 dark:bg-neutral-900">
          <header className="border-b bg-white dark:bg-neutral-800">
            <div className="container mx-auto px-4 py-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <i className="fa-solid fa-map-location-dot text-2xl text-neutral-800 dark:text-white"></i>
                  <span className="text-xl dark:text-white">Select teams</span>
                </div>
                <button
                  onClick={onClose}
                  className="text-neutral-600 dark:text-neutral-400 hover:text-neutral-800 dark:hover:text-white"
                >
                  <i className="fa-solid fa-xmark text-2xl"></i>
                </button>
              </div>
            </div>
          </header>

          <main className="m-h-120 container mx-auto px-4 py-10">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              {groups.map((group) => (
                <div
                  key={group.id}
                  className={`bg-white dark:bg-neutral-800 rounded-xl border dark:border-neutral-700 p-6 cursor-pointer transition-all ${group.selected
                    ? "ring-2 ring-neutral-800 dark:ring-neutral-600"
                    : "hover:shadow-lg"
                    }`}
                  onClick={() => handleGroupToggle(group.id!)}
                >
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-xl font-semibold text-neutral-800 dark:text-white">
                      {group.name}
                    </h3>
                    <div
                      className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${group.selected
                        ? "bg-neutral-800 dark:bg-neutral-600 border-neutral-800 dark:border-neutral-600"
                        : "border-neutral-300 dark:border-neutral-600"
                        }`}
                    >
                      {group.selected && (
                        <i className="fa-solid fa-check text-white text-sm"></i>
                      )}
                    </div>
                  </div>
                  <div className="space-y-2">
                    <span className="text-sm text-neutral-600 dark:text-neutral-400">
                      Description: 
                    </span>
                    <span>
                      {/* {team.users.map((user) => (
                        <span
                          key={user.address}
                          className="px-2 py-1 bg-neutral-100 dark:bg-neutral-700 rounded text-xs text-neutral-700 dark:text-neutral-300"
                        >
                          {area}
                        </span>
                      ))} */}
                      {
                        group.description
                      }
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex justify-end max-w-4xl mx-auto">
              <button
                onClick={handleAddSelected}
                disabled={!groups.some((group) => group.selected)}
                className="flex items-center gap-2 bg-neutral-800 dark:bg-neutral-600 hover:bg-neutral-700 dark:hover:bg-neutral-500 text-white px-6 py-3 rounded-lg font-medium shadow transition disabled:bg-neutral-300 dark:disabled:bg-neutral-700"
              >
                <i className="fa-solid fa-plus"></i>
                Add Selected teams
              </button>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
